import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
	Button,
	Card,
	Col,
	Flex,
	Form,
	notification,
	Row,
	Steps,
	Typography,
} from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/pro-regular-svg-icons";

import { GET } from "../../../providers/useAxiosQuery";
import {
	checkNetworkStatus,
	checkPermissions,
	readFile,
	setFileStorage,
} from "../../../providers/useCapacitorStorage";
import ModalPreviewAnswer from "./components/ModalPreviewAnswer";
import QuestionContent from "./components/QuestionContent";
import backToTop from "../../../providers/backToTop";

export default function PageSurveyForm() {
	const params = useParams();
	const navigate = useNavigate();
	const [form] = Form.useForm();
	const [toggleModalPreview, setToggleModalPreview] = useState(false);
	const [steps, setSteps] = useState([]);
	const [currentStep, setCurrentStep] = useState(0);
	const [stepPercent, setStepPercent] = useState(0);
	const [dataSource, setDataSource] = useState(null);
	const [dataQuestionAll, setDataQuestionAll] = useState([]);
	const [dataQuestion, setDataQuestion] = useState([]);
	const [answers, setAnswers] = useState(null);

	GET(
		`api/form?from=SurveyMobile`,
		"form_list",
		async (res) => {
			if (res && res.data) {
				let data = res.data;

				let findForm = data.find(
					(f) => Number(f.id) === Number(params.form_id),
				);

				// console.log("form_list find Form: ", findForm);

				if (findForm) {
					setDataSource(findForm);

					let stepsTemp = [];
					findForm.form_question_categories.forEach((item) => {
						stepsTemp.push({
							title: <div className="title">{item.category}</div>,
							content: item,
						});
					});
					setSteps(stepsTemp);
				}

				let dataSurveyFiltered = data.filter(
					(f) => f.form_question_categories.length > 0,
				);

				try {
					let resCheckPermissions = await checkPermissions();

					if (
						resCheckPermissions &&
						resCheckPermissions.publicStorage === "granted"
					) {
						try {
							let resReadFile = await readFile(
								"fsuu_dsac_survey_diosys/form_list.txt",
							);

							if (resReadFile && resReadFile.data) {
								resReadFile = JSON.parse(resReadFile.data);
								// Merge logic: update items if exist, add if not
								let mergedArray = [...resReadFile];
								dataSurveyFiltered.forEach((filteredItem) => {
									const index = mergedArray.findIndex(
										(item) => item.id === filteredItem.id,
									);
									if (index !== -1) {
										// Update existing item
										mergedArray[index] = filteredItem;
									} else {
										// Add new item
										mergedArray.push(filteredItem);
									}
								});
								// mergedArray now contains the merged result
								// You can use mergedArray as needed, e.g. set state or save to file

								try {
									let resSetFileStorage = await setFileStorage(
										"fsuu_dsac_survey_diosys",
										"form_list",
										mergedArray,
									);

									if (resSetFileStorage) {
										let findForm = mergedArray.find(
											(f) => Number(f.id) === Number(params.form_id),
										);

										if (findForm) {
											let allQuestions = [];
											let stepsTemp = [];

											findForm.form_question_categories.forEach(
												(item, index) => {
													allQuestions.push(...item.form_questions);
													stepsTemp.push({
														title: <div className="title">{item.category}</div>,
														content: item,
													});
													if (index === 0) {
														setDataQuestion(item.form_questions);
													}
												},
											);

											setSteps(stepsTemp);
											setDataSource(findForm);
											setDataQuestionAll(allQuestions);
										}
									}
								} catch (error) {
									console.error("Error saving mergedArray to file: ", error);
								}
							}
						} catch (error) {
							console.error("Error reading file: ", error);
						}
					}
				} catch (error) {
					console.error("Error checking permissions or reading files: ", error);
				}
			}
		},
		false,
	);

	useEffect(() => {
		const handleReadFile = async () => {
			try {
				let resCheckNetworkStatus = await checkNetworkStatus();

				if (resCheckNetworkStatus?.connected) {
					// connected
				} else {
					try {
						let resReadFile = await readFile(
							"fsuu_dsac_survey_diosys/form_list.txt",
						);

						if (resReadFile && resReadFile.data) {
							resReadFile = JSON.parse(resReadFile.data);
							let findForm = resReadFile.find(
								(f) => Number(f.id) === Number(params.form_id),
							);
							console.log("form_list find Form2: ", findForm);

							if (findForm) {
								let stepsTemp = [];
								let allQuestions = [];

								findForm.form_question_categories.forEach((item, index) => {
									allQuestions.push(...item.form_questions);
									stepsTemp.push({
										title: <div className="title">{item.category}</div>,
										content: item,
									});

									// Ensure the first set of questions is loaded on initial render
									if (index === 0) {
										setDataQuestion(item.form_questions);
									}
								});

								setSteps(stepsTemp);
								setDataQuestionAll(allQuestions);
								setDataSource(findForm);
							}
						}
					} catch (error) {
						console.error("Error reading file: ", error);
						notification.warning({
							message: "Warning",
							description:
								"Unable to read the file: either no permission or the file was not found.",
							duration: 10,
						});
					}
				}
			} catch (error) {
				console.error("Error checking network status: ", error);
			}
		};

		handleReadFile();

		return () => {};
	}, [params]);

	const onFinish = (values) => {
		let newAnswers = { ...answers, ...values };
		setAnswers(newAnswers);

		if (currentStep !== dataSource.form_question_categories.length - 1) {
			let currentStepTemp = currentStep + 1;

			let form_question_categories = dataSource.form_question_categories;
			let form_questions =
				form_question_categories[currentStepTemp].form_questions;

			setDataQuestion(form_questions);

			setCurrentStep(currentStepTemp);
		} else {
			setToggleModalPreview(true);
		}

		setStepPercent(0);

		backToTop(".private-layout");
	};

	const onValuesChange = (changedValues, allValues) => {
		let form_question_categories = dataSource.form_question_categories;

		if (currentStep !== form_question_categories.length - 1) {
			let form_questions = form_question_categories[currentStep].form_questions;
			let count = form_questions.length;
			let percent = 100 / count;
			let answered = 0;

			Object.keys(allValues).forEach((key) => {
				if (!key.includes("_other") && !key.includes("qo")) {
					if (allValues[key] !== undefined) {
						let q_id = key.split("_")[1];
						answered += dataQuestionAll.filter(
							(item) => Number(item.id) === Number(q_id),
						).length;
					}
				}
			});

			setStepPercent(percent * answered);
		}
	};

	return (
		<Form
			form={form}
			onFinish={onFinish}
			scrollToFirstError={true}
			onValuesChange={onValuesChange}
		>
			<Row gutter={[12, 0]}>
				<Col
					xs={24}
					sm={24}
					md={24}
					lg={24}
					xl={24}
					className="form-name-wrapper"
				>
					<Button
						type="link"
						className="btn-back"
						icon={<FontAwesomeIcon icon={faArrowLeft} />}
						onClick={() => navigate(-1)}
					/>
					<div className="form-name">
						<Typography.Title level={5}>
							{dataSource && dataSource.form_name}
						</Typography.Title>
					</div>
				</Col>

				<Col xs={24} sm={24} md={24} lg={24} xl={24}>
					{steps.length > 0 ? (
						<Card
							title={
								<>
									<div className="title-wrapper">
										{steps[currentStep].title}
									</div>
									<Steps
										current={currentStep}
										percent={stepPercent}
										items={steps}
									/>
								</>
							}
						>
							<div className="steps-mobile-wrapper">
								<Steps
									current={currentStep}
									percent={stepPercent}
									items={steps}
								/>
							</div>

							<div className="question-wrapper">
								{dataQuestion && dataQuestion.length ? (
									<Row gutter={[20, 0]}>
										{dataQuestion.map((item, index) => {
											return (
												<Col
													xs={24}
													sm={24}
													md={24}
													lg={24}
													xl={24}
													key={index}
												>
													<QuestionContent
														namePath={[`q_${item.id}`]}
														question={item.question}
														description={item.description}
														type={item.question_type}
														required={item.required ? true : false}
														max_checkbox={
															item.max_checkbox ? item.max_checkbox : 0
														}
														escape_questions={
															item.escape_questions ? item.escape_questions : []
														}
														form_question_options={
															item.form_question_options.length
																? item.form_question_options
																: []
														}
													/>
												</Col>
											);
										})}
									</Row>
								) : null}
							</div>
						</Card>
					) : null}
				</Col>

				<Col xs={24} sm={24} md={24} lg={24} xl={24}>
					<Flex gap={15} justify="center">
						<Button
							disabled={currentStep === 0}
							onClick={() => {
								if (currentStep > 0) {
									let currentStepTemp = currentStep - 1;

									let count = dataQuestion.length;
									let percent = 100 / count;
									let form_question_categories =
										dataSource.form_question_categories;
									let answered = 0;
									let form_questions =
										form_question_categories[currentStepTemp].form_questions;

									Object.keys(answers).forEach((key) => {
										if (!key.includes("_other") && !key.includes("qo")) {
											if (answers[key] !== undefined) {
												let q_id = key.split("_")[1];
												answered += form_questions.filter(
													(item) => Number(item.id) === Number(q_id),
												).length;
											}
										}
									});

									setStepPercent(percent * answered);
									setCurrentStep(currentStepTemp);
									setDataQuestion(form_questions);

									form.setFieldsValue(answers);
								} else {
									setCurrentStep(0);
								}

								backToTop(".private-layout");
							}}
						>
							Back
						</Button>

						{currentStep ===
						(dataSource && dataSource.form_question_categories.length - 1) ? (
							<Button
								htmlType="submit"
								type="primary"
								className="btn-main-primary"
							>
								Preview
							</Button>
						) : (
							<Button
								htmlType="submit"
								type="primary"
								className="btn-main-primary"
							>
								Next
							</Button>
						)}
					</Flex>
				</Col>
			</Row>

			<ModalPreviewAnswer
				toggleModalPreview={toggleModalPreview}
				setToggleModalPreview={setToggleModalPreview}
				dataSource={dataSource}
				answers={answers}
				dataQuestionAll={dataQuestionAll}
			/>
		</Form>
	);
}
